var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5957 9.14998C9.5957 8.92897 9.6835 8.717 9.83978 8.56072C9.99606 8.40444 10.208 8.31665 10.429 8.31665C10.6501 8.31665 10.862 8.40444 11.0183 8.56072C11.1746 8.717 11.2624 8.92897 11.2624 9.14998V14.15C11.2624 14.371 11.1746 14.583 11.0183 14.7392C10.862 14.8955 10.6501 14.9833 10.429 14.9833C10.208 14.9833 9.99606 14.8955 9.83978 14.7392C9.6835 14.583 9.5957 14.371 9.5957 14.15V9.14998ZM10.429 5.04248C10.208 5.04248 9.99606 5.13028 9.83978 5.28656C9.6835 5.44284 9.5957 5.6548 9.5957 5.87581C9.5957 6.09683 9.6835 6.30879 9.83978 6.46507C9.99606 6.62135 10.208 6.70915 10.429 6.70915C10.6501 6.70915 10.862 6.62135 11.0183 6.46507C11.1746 6.30879 11.2624 6.09683 11.2624 5.87581C11.2624 5.6548 11.1746 5.44284 11.0183 5.28656C10.862 5.13028 10.6501 5.04248 10.429 5.04248Z",
    fill: "#828FAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.429 1.66675C5.82654 1.66675 2.0957 5.39758 2.0957 10.0001C2.0957 14.6026 5.82654 18.3334 10.429 18.3334C15.0315 18.3334 18.7624 14.6026 18.7624 10.0001C18.7624 5.39758 15.0315 1.66675 10.429 1.66675ZM3.76237 10.0001C3.76237 11.7682 4.46475 13.4639 5.71499 14.7141C6.96523 15.9644 8.66093 16.6667 10.429 16.6667C12.1971 16.6667 13.8928 15.9644 15.1431 14.7141C16.3933 13.4639 17.0957 11.7682 17.0957 10.0001C17.0957 8.23197 16.3933 6.53628 15.1431 5.28604C13.8928 4.03579 12.1971 3.33341 10.429 3.33341C8.66093 3.33341 6.96523 4.03579 5.71499 5.28604C4.46475 6.53628 3.76237 8.23197 3.76237 10.0001Z",
    fill: "#828FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.23ab054d.svg";
export { ForwardRef as ReactComponent };